import { Card } from '@zenid/web';
import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router';
import { css } from '../../../styled-system/css';
import { flex } from '../../../styled-system/patterns';
import { Unauthorized } from '../../components/Error/Unauthorized';
import { ChangeForm } from '../../features/emailChange/components/ChangeForm';
import { isHighschoolEmail } from '../../features/highschool';
import { signInToIntegrationApp } from '../../features/integration/additional-sign-in';
import { IntegrationEmailSendComplete } from '../../features/integration/components/IntefrationEmailSendComplete';
import { useIntegrationForm } from '../../features/integration/hooks/useIntegrationForm';
import { useLoginRequired } from '../../utils/auth/useLoginRequired';
import { useTitle } from '../../utils/useTitle';
import { useAuth } from '#/utils/auth/useAuth';

export function IntegrationFormPage() {
  useLoginRequired();
  useTitle('サブメールアドレス追加');
  const [isError, setIsError] = useState(false);
  const [searchParams] = useSearchParams();

  const { user } = useAuth();
  if (!isHighschoolEmail(user?.email)) {
    setIsError(true);
  }

  // 統合完了後にログイン元アプリへ戻すため、Actionが付与した client_id を callbackClientId として引き回す
  const callbackClientId = searchParams.get('client_id') ?? undefined;

  // form のハンドラとフォーム下部のリンクの両方に使用する
  const redirectToIntegrationAppSignIn = useCallback(
    (loginHint?: string) => {
      const screenHint = searchParams.get('screen_hint') ?? undefined;
      signInToIntegrationApp({ screenHint, loginHint }).catch(() => {
        setIsError(true);
      });
    },
    [searchParams]
  );

  const { onSubmit, isSuccess, register, formState, email } = useIntegrationForm({
    onExistingAccount: redirectToIntegrationAppSignIn,
    callbackClientId,
  });

  if (isError) {
    return <Unauthorized />;
  }
  if (isSuccess) {
    return <IntegrationEmailSendComplete email={email} />;
  }
  return (
    <div
      className={flex({ alignItems: 'center', padding: '{spacing.20} {spacing.16}', sm: { padding: '{spacing.80}' } })}
    >
      <Card className={css({ backgroundColor: '{colors.background.white}' })}>
        <div
          className={flex({
            padding: '{spacing.20} {spacing.20} {spacing.40} {spacing.20}',
            flexDirection: 'column',
            justifyContent: 'center',
            sm: {
              padding: '{spacing.40}',
            },
          })}
        >
          <h1
            className={css({
              textStyle: 'headding.l',
              paddingTop: '{spacing.24}',
              paddingBottom: '{spacing.16}',
              textAlign: 'center',
              color: '{colors.text.main}',
            })}
          >
            サブメールアドレスの追加
          </h1>
          <p className={css({ textStyle: 'body.m.default', color: '{colors.text.sub}', textAlign: 'center' })}>
            新しいメールアドレスを入力してください。
          </p>
        </div>
        <ChangeForm onSubmit={onSubmit} register={register} formState={formState} />
        <div
          className={flex({
            padding: '0 {spacing.40} {spacing.40}',
            marginTop: '-20px', // ChangeForm の props で調整可能にする
            flexDirection: 'column',
            justifyContent: 'center',
          })}
        >
          <p className={css({ textStyle: 'body.m.default', color: '{colors.text.sub}' })}>
            個人のZEN IDを既にお持ちの方は
            <button
              onClick={() => redirectToIntegrationAppSignIn()}
              className={css({
                color: '{colors.action.primary.main}',
                fontWeight: 'bold',
                border: 'none',
                background: 'none',
                textDecoration: 'underline',
                textStyle: 'inherit',
                cursor: 'pointer',
              })}
            >
              こちら
            </button>
          </p>
        </div>
      </Card>
    </div>
  );
}
